import React from 'react';
import { Sparkles } from 'lucide-react';

const categories = [
  {
    title: "Costumes & Tailleurs",
    color: "blue",
    items: [
      "Costumes 2 & 3 pièces",
      "Costumes de mariage",
      "Smokings & habits",
      "Tailleurs femme (jupe / pantalon)",
      "Vestes, pantalons de costume",
      "Gilets, redingotes"
    ]
  },
  {
    title: "Robes & Cérémonie",
    color: "pink",
    items: [
      "Robes de mariée",
      "Robes de soirée",
      "Robes de cocktail",
      "Robes pailletées / dentelle",
      "Robes longues & courtes",
      "Tenues de cérémonie"
    ]
  },
  {
    title: "Manteaux & Doudounes",
    color: "amber",
    items: [
      "Manteaux laine & cachemire",
      "Trenchs, cabans, pardessus",
      "Doudounes plume & duvet",
      "Doudounes synthétiques",
      "Parkas & anoraks",
      "Vestes d'hiver"
    ]
  },
  {
    title: "Cuir & Blousons",
    color: "stone",
    items: [
      "Vestes en cuir",
      "Blousons de motard",
      "Manteaux en cuir",
      "Cuir nettoyé en profondeur",
      "Protection & souplesse",
      "Nourri & assoupli"
    ]
  },
  {
    title: "Chemises & Quotidien",
    color: "sky",
    items: [
      "Chemises homme",
      "Chemisiers & blouses femme",
      "Polos, pulls",
      "Pantalons, jeans, jupes",
      "Écharpes, foulards, cravates",
      "Repassage professionnel"
    ]
  },
  {
    title: "Accessoires & Sport",
    color: "emerald",
    items: [
      "Casquettes & bonnets",
      "Baskets blanches & sneakers",
      "Chaussures de sport",
      "Combinaisons de ski",
      "Sacs de couchage",
      "Équipements outdoor"
    ]
  },
  {
    title: "Literie complète",
    color: "violet",
    items: [
      "Couettes (jusqu'à 240×260)",
      "Couvertures, plaids",
      "Dessus-de-lit, jetés de lit",
      "Édredons, oreillers, traversins",
      "Draps, housses de couette",
      "PROMO Longpont : Couettes 18€"
    ]
  },
  {
    title: "Textiles d'intérieur",
    color: "cyan",
    items: [
      "Rideaux & voilages",
      "Housses de canapé",
      "Coussins, housses de chaise",
      "Nappes & serviettes",
      "Tissus d'ameublement",
      "Tentures murales"
    ]
  }
];

const accentClasses = {
  blue: "border-blue-600 bg-blue-50 text-blue-700",
  pink: "border-pink-500 bg-pink-50 text-pink-700",
  amber: "border-amber-500 bg-amber-50 text-amber-700",
  stone: "border-stone-600 bg-stone-50 text-stone-700",
  sky: "border-sky-500 bg-sky-50 text-sky-700",
  emerald: "border-emerald-500 bg-emerald-50 text-emerald-700",
  violet: "border-violet-500 bg-violet-50 text-violet-700",
  cyan: "border-cyan-500 bg-cyan-50 text-cyan-700"
};

const dotClasses = {
  blue: "bg-blue-500",
  pink: "bg-pink-500",
  amber: "bg-amber-500",
  stone: "bg-stone-500",
  sky: "bg-sky-500",
  emerald: "bg-emerald-500",
  violet: "bg-violet-500",
  cyan: "bg-cyan-500"
};

export const TextileServicesSection = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-testid="textile-services-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-blue-100 text-[#0205B3] px-4 py-2 rounded-full text-sm font-medium mb-4">
            <Sparkles className="h-4 w-4" />
            <span>Tous nos services détaillés</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Nettoyage de tous vos textiles
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            <strong>Pressing AQUABLUENET</strong> nettoie <strong>costumes, tailleurs, robes de mariée, robes de soirée, manteaux, doudounes, vestes en cuir, blousons de motard, chemises, casquettes, baskets, couettes, couvertures, dessus-de-lit, oreillers</strong> et tous textiles — avec la technologie écologique <strong>Lagoon 0% Perchlo</strong>.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((cat) => (
            <div
              key={cat.title}
              className={`border-2 rounded-2xl p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 ${accentClasses[cat.color]}`}
              data-testid={`textile-cat-${cat.title}`}
            >
              <h3 className="text-xl font-bold mb-4">{cat.title}</h3>
              <ul className="space-y-2">
                {cat.items.map((item) => (
                  <li key={item} className="flex items-start text-sm text-gray-700">
                    <span className={`${dotClasses[cat.color]} h-1.5 w-1.5 rounded-full mr-2 mt-1.5 flex-shrink-0`}></span>
                    <span className="leading-snug">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            Un textile non listé ? Nous le nettoyons aussi !
          </h3>
          <p className="text-gray-700 max-w-3xl mx-auto">
            Contactez directement nos 2 pressings <strong>AQUABLUENET</strong> à <strong>Longpont-sur-Orge (01 69 80 73 75)</strong> ou <strong>Mennecy (09 84 50 99 42)</strong>. Nos experts vous conseillent sur la meilleure technique de nettoyage pour chaque matière.
          </p>
        </div>
      </div>
    </section>
  );
};
